export default __webpack_public_path__ + "static/media/node-js-image.acf87e47.jpg";